<template>
    <div class="topbar d-flex">
        <div class="container">
            <div class="d-inline">
                <!--<span class=" sidebar-toggler icon icon-cph_iconset_burger_new"
                    @click="updateSidebarOpenFlag(!sidebarOpen)"></span>-->
                <router-link tag="button" class="btn btn-xs lefticon pull-left" exact to="/">
                    <!--<span class="icon-logo-expanded icon-cph_iconset_cph_headerlogo"
                        v-if="sidebarOpen"/>-->
                    <span class="icon-cph_iconset_cloudprinthub"></span>
                    <span class="text"> CloudPrintHub </span>
                </router-link>
            </div>

            <div class="top-menu d-inline d-flex align-items-center">
                <router-link role="button"
                    class="btn btn-default" :to="`/${$TYPES.ROUTES.SHOPS}`">
                <i class="fa fa-archive mr-2"></i>MANAGE&nbsp;SHOPS</router-link>
                <Guard :hideFor="['shop_owner']">
                    <router-link role="button"
                        class="btn btn-default" :to="`/${$TYPES.ROUTES.REGISTRATION}/shop`">
                    <i class="fa fa-shopping-cart mr-2"></i>NEW SHOP</router-link>
                </Guard>
                <router-link role="button"
                    class="btn btn-default" :to="`/analytics/select`">
                <i class="fa fa-signal mr-2"></i>STATISTICS</router-link>
                <Guard :hideFor="['shop_owner', 'key_account']">
                  <router-link role="button"
                      class="btn btn-default" :to="`/devices`">
                  <i class="fa fa-align-justify mr-2"></i>DEVICES</router-link>
                </Guard>

            </div>

            <div class="d-inline d-flex justify-content-end align-items-center">
                <el-dropdown>
                    <span class="options-link icon icon-cph_iconset-Kopie_cog"/>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="dropdown-item">
                            <router-link tag="a"
                                        class="dropdown-item d-flex align-items-center"
                                        exact
                                        :to="$TYPES.ROUTES.ACCOUNT"
                                        v-if="$viewSidebar.isAllowed('viewLink', $TYPES.ROUTES.ACCOUNT)">
                                <span class="icon icon-cph_iconset_user pr-2"></span>
                                <span @click="dropdownOpened = false">
                                    {{$t('COMMON.account')}}
                                </span>
                            </router-link>
                        </el-dropdown-item>
                        <el-dropdown-item class="dropdown-item">
                            <a tag="a" class="dropdown-item d-flex align-items-center"
                            name="logout"
                            @click="dropdownOpened = false; logout(); ">
                                <span class="icon icon-cph_iconset_log-out pr-2"/>
                                <span>Logout</span>
                            </a>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapMutations } from 'vuex';
import { SidebarPerimeter } from '../../../router/perimeters/sidebarPerimeter';
import { ThemePicker } from './themePicker/themePicker';
import TopBarLink from './TopBarLink.vue';

export default {
    name: 'CphTopBar',
    data () {
        return {
            dropdownOpened: false
        };
    },
    components: { TopBarLink },
    computed: {
        ...mapGetters({
            sidebarOpen: 'getSidebarOpenFlag'
        }),
        locale () {
            return this.$i18n.locale();
        }
    },
    perimeters: [
        // ConfigPerimeter,
        SidebarPerimeter
    ],
    methods: {
        ...ThemePicker,
        ...mapMutations([
            'updateSidebarOpenFlag',
            'setLocale',
            'updateUser'
        ]),
        openDropdown (){
            this.dropdownOpened = !this.dropdownOpened;
            if(this.dropdownOpened === true){
                //window.addEventListener("click", this.openDropdown);
            }else{
                //window.removeEventListener("click", this.openDropdown);
            }
        },
        closeDropdown (){
            this.dropdownOpened = false;
        },
        changeLanguage (language) {
            this.$i18n.set(language);
        },
        isActive (language) {
            return this.locale === language;
        },
        logout () {
            this.updateUser({
                role: 'user',
                loggedIn: false
            });
            window.localStorage.removeItem('tokenCPH');
            window.localStorage.removeItem('tokenCreationDate');
            window.localStorage.removeItem('Store');
            this.$router.push({name: 'Login'});
        }
    }
};

</script>

<style lang="scss" scoped>
    .top-menu a {
        opacity: 1;
        color: #fff;
        transition: opacity 600ms ease;
        width: max-content;
        &:hover {
            opacity: .6;
        }
    }
    .container {
        display: flex;
        justify-content: space-between;
    }
    .lefticon{
        &:focus{
            box-shadow: none;
        }
        &.btn{
            padding: 0;
            background-color: transparent;
            border: none;
            color: #ffffff;
            height: 100%;
            margin: 0;
        }
        .icon-cph_iconset_cloudprinthub{
            height: 100%;
            font-size: 50px;
            width: 60px;
            color: #ffffff;
            &:focus{
                outline: none;
            }
        }
        .text{
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            position: absolute;
            top: 0;
            padding-left: 10px;
        }
    }
    .topbar {
        height: 50px;
        @include color('background-color', primary);
    }

    .left, .right {
        width: 50%;
    }

    #dropdownMenuLink {
        cursor: pointer;
    }

    .sidebar-toggler {
        display: block;
        cursor: pointer;
        font-size: 2em;
        margin-left: 1.25rem;
        background-color: transparent;
        @include color('color', background-color-light);
    }

    .options-link {
        font-size: 3rem;
        @include color('color', background-color-light);
    }

    .dropdown-menu {
        right: 0;
        top: 2.5rem;
        left: initial;
        display: block;
    }

    #dropdownMenuButton, .dropdown-item {
        cursor: pointer;
    }

    .dropdown-header {
        .icon {
            font-size: 1.5em;
        }
    }

    .dropdown-item {
        background-color: unset;
        text-decoration: none;
        color: unset;
        &.activeLanguage {
            text-decoration: underline;
        }
        .icon {
            color: #c4c4c4;
            font-size: 1.5em;
        }
    }
    @media only screen and (max-width: 997px) {
        .text {
            display: none;
        }
    }
    @media only screen and (max-width: 778px) {
        .text {
            display: none;
        }
        .top-menu {
            & a {
                font-size: unset;
                padding: 0 0.1rem;

                & i {
                    margin-right: 0.1rem !important;
                }
            }

        }
        .options-link, .icon-cph_iconset_cloudprinthub {
            font-size: 2rem !important;
        }
    }
    @media only screen and (max-width: 430px) {
        .top-menu a i {
            display: none;
        }
    }
</style>
